import React from 'react';
import { motion } from 'framer-motion';
import { SectionEyebrow } from './SectionEyebrow';
import { Reveal } from './Reveal';
const STATS = [['+ 96', 'Projects Completed'], ['+ 5', 'Years of Experience'], ['98%', 'Client Satisfaction'], ['+ 7', 'Different countries served']];
const SKILLS = [{
  name: 'Creativity',
  pct: 95,
  text: 'We bring fresh ideas to the table and stay ahead of industry trends to ensure your brand remains cutting-edge'
}, {
  name: 'Digital Strategy',
  pct: 85,
  text: 'We take the time to understand your unique goals and challenges, delivering customized strategies that align perfectly with your vision.'
}, {
  name: 'Web Development',
  pct: 100,
  text: 'We’re not just about creating something that looks good—we’re about making it work.'
}];
export function WhyUs() {
  return <section className="mx-auto w-full max-w-7xl px-5 py-24 lg:px-8" data-id="element-235" data-mp="3s95f4n2ra3fm">
      <SectionEyebrow label="Why Work with Us?" data-id="element-236" data-mp="3nau62ekabwyg" />
      <Reveal anim="slideInLeft" data-id="element-237" data-mp="3nc5fatwi1wwy">
        <h2 className="mt-8 font-heading text-4xl uppercase leading-[1.02] text-white sm:text-5xl lg:text-6xl" data-id="element-238" data-mp="3nd6vtdwabbm2">We’re your creative <span className="text-[#FFB700]" data-id="element-239" data-mp="3j9mq676mh5vm">partners</span></h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-2 gap-6 lg:grid-cols-4" data-id="element-240" data-mp="3j7idp0unqyjq">
        {STATS.map(([n, l]) => <div key={l} className="border-l-2 border-[#FFB700] pl-5" data-id="element-241" data-mp="3n9n9a54o2590">
            <p className="font-heading text-4xl text-white sm:text-5xl" data-id="element-242" data-mp="3s3hn4rxlbq06">{n}</p>
            <p className="mt-2 text-sm uppercase tracking-widest text-[#B2B2B2]" data-id="element-243" data-mp="v3sk1s7ydzd">{l}</p>
          </div>)}
      </div>
      <Reveal anim="slideInUp" className="mt-16 grid grid-cols-1 gap-10 md:grid-cols-3" data-id="element-244" data-mp="5t5csq1dsjcf">
        {SKILLS.map(s => <div key={s.name} data-id="element-245" data-mp="as8jeex0exmi">
            <div className="flex items-end justify-between" data-id="element-246" data-mp="ew6e8dfaxm9r">
              <h5 className="font-heading text-lg uppercase text-white" data-id="element-247" data-mp="etbxavvhyjl3">{s.name}</h5>
              <h3 className="font-heading text-2xl text-[#FFB700]" data-id="element-248" data-mp="2cn928urxvjc6">{s.pct}%</h3>
            </div>
            <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-[#313131]" data-id="element-249" data-mp="2gnb5v9h8imu3">
              <motion.div className="h-full rounded-full bg-[#FFB700]" initial={{
            width: 0
          }} whileInView={{
            width: `${s.pct}%`
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.2,
            ease: 'easeOut'
          }} data-id="element-250" data-mp="3jyguf1n31w1k" />
            </div>
            <p className="mt-4 text-[15px] leading-relaxed text-[#B2B2B2]" data-id="element-251" data-mp="3swafthjb759y">{s.text}</p>
          </div>)}
      </Reveal>
    </section>;
}